import React, { useState } from 'react';
import ReactDOM from 'react-dom';

const DEFAULTS = {
  minPrice: '',
  maxPrice: '',
  hasInterested: 0,
  priceType: null,
  condition: null,
  madeToOrder: null,
};

function FilterModal({ filters, onApply, onClose }) {
  const [local, setLocal] = useState({ ...DEFAULTS, ...filters });

  const handleApply = () => {
    onApply(local);
    onClose();
  };

  const handleClear = () => {
    onApply({ ...DEFAULTS });
    onClose();
  };

  return ReactDOM.createPortal(
    <div className="filter-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="filter-modal">
        <div className="filter-modal-header">
          <h3>Filtros avanzados</h3>
          <button className="btn-text" onClick={onClose} style={{ fontSize: '1.3rem', padding: 0, lineHeight: 1 }}>✕</button>
        </div>

        <div className="filter-modal-body">
          {/* Price range */}
          <div className="filter-section">
            <div className="filter-section-title">Rango de precio</div>
            <div className="filter-row">
              <input
                type="number"
                min="0"
                className="search-input"
                placeholder="Sin límite"
                value={local.minPrice}
                onChange={(e) => setLocal((s) => ({ ...s, minPrice: e.target.value }))}
                style={{ flex: 1 }}
              />
              <span style={{ color: 'var(--text-muted)', fontWeight: 600 }}>—</span>
              <input
                type="number"
                min="0"
                className="search-input"
                placeholder="Sin límite"
                value={local.maxPrice}
                onChange={(e) => setLocal((s) => ({ ...s, maxPrice: e.target.value }))}
                style={{ flex: 1 }}
              />
            </div>
          </div>

          {/* Has interested */}
          <div className="filter-section">
            <div className="filter-section-title">Tiene interesados</div>
            <div className="filter-radio-group">
              {[
                { value: 0, label: 'Ambos' },
                { value: 1, label: 'Sí' },
                { value: 2, label: 'No' },
              ].map((opt) => (
                <label key={opt.value} className={`radio-option${local.hasInterested === opt.value ? ' selected' : ''}`}>
                  <input
                    type="radio"
                    name="hasInterested"
                    checked={local.hasInterested === opt.value}
                    onChange={() => setLocal((s) => ({ ...s, hasInterested: opt.value }))}
                    style={{ display: 'none' }}
                  />
                  {opt.label}
                </label>
              ))}
            </div>
          </div>

          {/* Price type */}
          <div className="filter-section">
            <div className="filter-section-title">Tipo de precio</div>
            <div className="filter-radio-group">
              {[
                { value: null, label: 'Ambos' },
                { value: 'FIXED', label: 'Precio fijo' },
                { value: 'CONSULTATION', label: 'A consultar' },
              ].map((opt) => (
                <label key={String(opt.value)} className={`radio-option${local.priceType === opt.value ? ' selected' : ''}`}>
                  <input
                    type="radio"
                    name="priceType"
                    checked={local.priceType === opt.value}
                    onChange={() => setLocal((s) => ({ ...s, priceType: opt.value }))}
                    style={{ display: 'none' }}
                  />
                  {opt.label}
                </label>
              ))}
            </div>
          </div>

          {/* Condition (New / Used) */}
          <div className="filter-section">
            <div className="filter-section-title">Estado del artículo</div>
            <div className="filter-radio-group">
              {[
                { value: null, label: 'Ambos' },
                { value: 'NEW', label: 'Nuevo' },
                { value: 'USED', label: 'Usado' },
              ].map((opt) => (
                <label key={String(opt.value)} className={`radio-option${local.condition === opt.value ? ' selected' : ''}`}>
                  <input
                    type="radio"
                    name="condition"
                    checked={local.condition === opt.value}
                    onChange={() => setLocal((s) => ({ ...s, condition: opt.value }))}
                    style={{ display: 'none' }}
                  />
                  {opt.label}
                </label>
              ))}
            </div>
          </div>

          {/* Made to order */}
          <div className="filter-section">
            <div className="filter-section-title">Fabricado a demanda</div>
            <div className="filter-radio-group">
              {[
                { value: null, label: 'Ambos' },
                { value: true, label: 'Sí' },
                { value: false, label: 'No' },
              ].map((opt) => (
                <label key={String(opt.value)} className={`radio-option${local.madeToOrder === opt.value ? ' selected' : ''}`}>
                  <input
                    type="radio"
                    name="madeToOrder"
                    checked={local.madeToOrder === opt.value}
                    onChange={() => setLocal((s) => ({ ...s, madeToOrder: opt.value }))}
                    style={{ display: 'none' }}
                  />
                  {opt.label}
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="filter-modal-footer">
          <button className="btn btn-secondary" onClick={handleClear}>Limpiar filtros</button>
          <button className="btn btn-primary" onClick={handleApply}>Aplicar</button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default FilterModal;
